<template>
  <section class="all_emp card_style">
    <div class="d-flex align-items-center mb-2 gap-3">
      <AddFavDailog v-tooltip.left="$t('add to favorites')" />
      <h4>
        {{ $t("Meta") }}
      </h4>
    </div>
    <div class="main_header_style mb-2">
      <div class="w-100 d-flex justify-content-between align-items-center">
        <div class="search-visa w-100">
          <form>
            <i class="fa-solid fa-magnifying-glass"></i>
            <input
              type="text"
              class="form-control w-50"
              :placeholder="$t('search...')"
              v-model="metaName"
              @keyup="fetchAllMeta((page = 1))"
            />
          </form>
        </div>
        <router-link to="/meta/add" class="PrimaryButton mt-0 btn w-25"
          ><i class="fa-solid fa-plus"></i> {{ $t("add meta") }}
        </router-link>
      </div>
    </div>

    <div class="row">
      <div class="table-responsive">
        <table class="table visaType" id="VisaTable">
          <thead>
            <tr>
              <th>ID</th>
              <th>{{ $t("meta_title") }}</th>
              <th>{{ $t("meta_description") }}</th>
              <th>{{ $t("meta_tags") }}</th>
              <th>{{ $t("meta_keywords") }}</th>
              <th>{{ $t("Control") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(meta, index) in allMeta.data" :key="index">
              <td>{{meta.id}}</td>
              <td>{{meta.meta_title}}</td>
              <td>{{meta.meta_description}}</td>
              <td>
                <div v-for="(tag , tagIndex) in meta.met_tags" :key="tagIndex">- {{tag.meta_tag}}</div>
              </td>
              <td>
                <div v-for="(tag , tagIndex) in meta.met_key_words" :key="tagIndex">- {{tag.meta_key_word}}</div>
              </td>
              <td>
                <router-link
                  :to="`/meta/edit/${meta.id}`"
                  class="btn btn-success mx-1 w-auto"
                >
                  <i class="fa-regular fa-pen-to-square"></i>
                </router-link>

                <div
                  class="btn btn-danger mx-1 w-auto"
                  @click="deleteMeta(index)"
                >
                  <i class="fa-solid fa-trash"></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <pagination
        :data="allMeta"
        class="mx-auto d-flex align-items-center justify-content-center pagination"
        @pagination-change-page="fetchAllMeta"
      >
        <template v-slot:prev-nav>&lt;</template>
        <template v-slot:next-nav>&gt;</template>
      </pagination>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import Swal from "sweetalert2";
import AddFavDailog from "@/components/layout/addFavDailog.vue";

export default {
  name: "metaIndex",
  components: {
    pagination,
    AddFavDailog,
  },
  data() {
    return {
      allMeta: [],
      metaName: "",
    };
  },
  methods: {
    fetchAllMeta(page = 1){
        axios.post(`/index_meta?page=${page}`).then(({data})=>{
            this.allMeta = data.data;
        })
    },

    //delete visa
    deleteMeta(index) {
      Swal.fire({
        title: this.$t("check_delete"),
        text: this.$t("are_you_sure_delete"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: this.$t("back"),
        confirmButtonText: this.$t("confirm_delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          let delete_id = this.allMeta.data[index].id;
          const fromClick = true;
          axios.delete(`/delete_meta/${delete_id}`, { fromClick }).then(({ data }) => {
            if (data.status == true) {
              Swal.fire("", data.message, "success");
              this.allMeta.data.splice(index, 1); // Remove the deleted item from the array
            } else {
              Swal.fire("", data.message, "error");
            }
            return data;
          });
        }
      });
    },
  },
  mounted() {
    this.fetchAllMeta();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.main_header_style {
  align-items: center;
  h4 {
    margin-bottom: 0;
  }
}
.search-visa {
  form {
    position: relative;
    i {
      position: absolute;
      top: 12px;
      right: 15px;
      color: #9ca2ac;
    }
    input {
      padding-right: 40px !important;
    }
  }
}
</style>
